import { useQueryClient } from "@tanstack/react-query";
import { editProperty } from "../api";
import { EditPropertyDTO } from "../dtos";
import { Property } from "../types";
import { useDomainMutation } from "@/modules/common/hooks/domain-mutation.hook";

export function useEditProperty() {
  const queryClient = useQueryClient();

  const mutationEditProperty = useDomainMutation<
    Property,
    { response?: { data?: { message?: string } } },
    { uid: string; data: EditPropertyDTO }
  >({
    mutationFn: ({ uid, data }: { uid: string; data: EditPropertyDTO }) => {
      return editProperty(uid, data);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["track"] });
    },
  });

  return mutationEditProperty;
}
